import { Editor } from '@ckeditor/ckeditor5-core';
import { AxiosError } from 'axios';
import { forwardRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorInfo } from '../../../../../api/model';
import { usePutSectionsUpdateRevisionTitle } from '../../../../../api/sections/sections';
import { useDefaultOptions } from '../../../../../hooks/api';

type Props = {
  editor: Editor;
  sectionId: number;
  revisionItem: RevisionItem;
  onClose: () => void;
};
type RevisionItem = {
  id: string;
  index: number;
  name: string;
  users: RevisionUser[];
  createdAt: moment.Moment;
  date: string;
};
type RevisionUser = {
  id: string;
  name: string;
};

const RevisionRenamePage = forwardRef((props: Props, ref) => {
  // Data
  const { editor, sectionId } = props;
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { revisionItem, onClose } = props;
  const [revisionName, setRevisionName] = useState<string>('');

  /* eslint-disable */
  const {
    mutateAsync: postSectionMutateAsync,
    isSuccess,
    error: saveError,
  } = usePutSectionsUpdateRevisionTitle<AxiosError<ErrorInfo>, unknown>(options);

  // Revision
  const revisionsRepository = editor.plugins.get('RevisionsRepository') as any;
  const revisions = revisionsRepository.getRevisions();

  // Common
  useEffect(() => {
    document.getElementById('revision-name')?.focus();
    setRevisionName(revisionItem.name);
  }, [revisionItem]);

  // Rename
  const handleSubmit = () => {
    postSectionMutateAsync(
      {
        data: {
          revision_id: revisionItem.id,
          section_id: sectionId,
          revision_name: revisionName,
        },
      },
      {
        onSuccess: () => {
          const revision = revisions.find((r: any) => r.id === revisionItem.id);
          if (revision) {
            revision.setName(revisionName);
            setShowSuccessContent(true);
            setTimeout(() => {
              setShowSuccessContent(false);
              onClose();
            }, 1500);
          }
        },
        onError: () => {
          console.error(saveError);
        },
      }
    );
  };
  /* eslint-enable */

  // Close
  const handleClose = () => {
    onClose();
  };

  // Success Content
  const [showSuccessContent, setShowSuccessContent] = useState(false);

  return (
    <div>
      <table id="comment-search-table">
        <tbody>
          <tr>
            <td>{t('改訂履歴名')}</td>
            <td style={{ width: '100%' }}>
              <input
                type="text"
                id="revision-name"
                value={revisionName}
                onChange={(e) => setRevisionName(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div style={{ display: 'flex', padding: '0 9px', marginTop: '25px', textAlign: 'center' }}>
        <div style={{ flex: 1 }}>
          <button
            style={{ paddingRight: '10px', letterSpacing: '0.1em' }}
            type="button"
            className="cancelbtn"
            onClick={handleClose}
          >
            {t('閉じる')}
          </button>
        </div>
        <div style={{ flex: 1 }}>
          {(showSuccessContent && (
            <div
              style={{
                color: '#4CAF50',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                paddingTop: '5px',
                textAlign: 'center',
              }}
            >
              ✅ {t('保存しました。')}
            </div>
          )) || (
            <input
              type="submit"
              style={{ paddingRight: '10px', letterSpacing: '0.1em' }}
              value={t('保存する').toString()}
              className="searchbtn"
              onClick={handleSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
});

export default RevisionRenamePage;
